module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8700/img/mobile-onboarding-powering-up.svg"